module.exports = __webpack_public_path__ + "img/kalmar_yes.ddddff91.png";